import React, { useEffect } from "react";
import {
  Box,
  useTheme,
  useMediaQuery,
  CircularProgress,
  Typography,
} from "./MuiImports";
import logo from "../../assets/images/boingo_logo.svg";

const GoodbyeHeader: React.FC = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Box
      data-test-id="ps-header"
      sx={{
        display: "flex",
        alignItems: "center",
        width: "100%",
        backgroundColor: "#3C434B",
        justifyContent: "center",
      }}
    >
      <Box
        data-test-id="ps-header-content"
        sx={{
          width: "100%",
          maxWidth: "1024px",
          display: "flex",
          alignItems: "center",
          padding: isMobile ? "12px 16px" : "10px 24px",
        }}
      >
        <img
          data-test-id="ps-header-logo"
          src={logo}
          alt="logo"
          style={{
            width: isMobile ? "70px" : "80px",
            height: "auto",
          }}
        />
      </Box>
    </Box>
  );
};

const Goodbye: React.FC = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Box sx={{ bgcolor: "rgb(245, 245, 245)" }}>
      <GoodbyeHeader />
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "flex-start",
          minHeight: "100vh",
          margin: isMobile ? "40px auto" : "80px auto",
          width: "90%",
        }}
      >
        <Box
          sx={{
            border: "1px solid rgba(84, 88, 97, 0.6)",
            borderRadius: "4px",
            padding: isMobile ? "16px" : "80px",
            bgcolor: "rgb(255, 255, 255)",
            textAlign: isMobile ? "center" : "",
          }}
        >
          <Typography
            component="h1"
            fontFamily="Figtree-ExtraBold"
            fontSize={isMobile ? "30px" : "35px"}
            color="rgba(84, 88, 97, 0.95)"
          >
            Thank you for using Boingo!
          </Typography>
          <Typography
            component="p"
            fontFamily="Figtree-Regular"
            color="rgba(84, 88, 97, 0.75)"
          >
            You are now logged out.
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default Goodbye;
